import { SwitchStatusType } from '@/api/circuit';

// 时间颗粒度
export enum Mode {
  H = 'H',
  V = 'V',
}

export const ModeDisplay = {
  [Mode.H]: '横屏',
  [Mode.V]: '竖屏',
};

export const SwitchStatusColor = {
  [SwitchStatusType.OPEN]: '#16DD8E',
  [SwitchStatusType.CLOSE]: '#E64242',
  [SwitchStatusType.NONE]: 'default',
};

export const StationColor: Record<number, string> = {
  2: 'linear-gradient( 225deg, #179EAA 0%, #0E8092 100%)',
  3: '#376BA8',
  4: '#91A510',
  5: '#C36728',
};

export const VerticalStationColor: Record<number, string> = {
  1: 'linear-gradient(to bottom, #1C6995, #184A78)',
  2: StationColor[2],
  3: StationColor[3],
  4: '#5F5D9C',
  5: StationColor[5],
};

export const VerticalStationLegend = [
  { level: 1, label: '35kV总站', description: '3个电网计费回路' },
  { level: 2, label: '一级站房', description: '直接由母线供电的配电站、箱变及总母线直供负载' },
  { level: 3, label: '二级站房', description: '由一级配电站或箱变二次分配的变电站' },
  { level: 4, label: '三级站房', description: '由二级变电站再次向下馈出的末端分支负荷站' },
];

// 站类型
export enum StationType {
  DistributionStation = 0, // 配电站
  AirCompressorStation = 1, // 空压站
  NitrogenProductionStation = 2, // 制氮站
}

export const StationTypeDisplay = {
  [StationType.DistributionStation]: '配电站',
  [StationType.AirCompressorStation]: '空压站',
  [StationType.NitrogenProductionStation]: '制氮站',
};
